import { c as _c } from "react/compiler-runtime";
// userExists(email: String!): Boolean!

import { graphql } from "@/graphql";
import { graphqlClient } from "@/lib/graphql-client";
import { useQuery } from "@tanstack/react-query";
const userExistsQuery = graphql(`
  query userExists($email: String!) {
    userExists(email: $email)
  }
`);
export function useCompanyUserExists(email, t0) {
  const $ = _c(7);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  let t2;
  if ($[0] !== email) {
    t1 = ["userExists", email];
    t2 = () => graphqlClient.request(userExistsQuery, {
      email
    }).then(_temp);
    $[0] = email;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = !!email && enabled;
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return useQuery(t4);
}
function _temp(res) {
  return res.userExists;
}